module.exports = __webpack_public_path__ + "img/course-editor.bfed13f.webp";